import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";

export const informationStatistics = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '销售',
            dataIndex: 'sales',
            key: 'sales',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            roles: ['sales'],
            filteredValue: filteredInfo.sales || [],
        },
        {
            title: '销售经理',
            dataIndex: 'salesManager',
            key: 'salesManager',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            roles: ['salesManager'],
            filteredValue: filteredInfo.salesManager || [],
        },
        {
            title: '团队审批未到款申请原始数据/分析结果/返样项目总金额',
            dataIndex: 'managerApprovalNoPaymentAmount',
            key: 'managerApprovalNoPaymentAmount',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            roles: ['salesManager'],
            filteredValue: filteredInfo.managerApprovalNoPaymentAmount || [],
        },
        {
            title: '加急审批项目数量',
            dataIndex: 'urgentApprovalCount',
            key: 'urgentApprovalCount',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            roles: ['salesManager'],
            filteredValue: filteredInfo.urgentApprovalCount || [],
        },
        {
            title: '扣除金额',
            dataIndex: 'deductionAmount',
            key: 'deductionAmount',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.deductionAmount || [],
        },
        {
            title: '团队费用使用情况',
            dataIndex: 'teamContractAmount',
            key: 'teamContractAmount',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            roles: ['salesManager'],
            filteredValue: filteredInfo.teamContractAmount || [],
        },
        {
            title: '合同数量',
            dataIndex: 'numberOfContracts',
            key: 'numberOfContracts',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.numberOfContracts || [],
        },
        {
            title: '合同金额',
            dataIndex: 'contractAmount',
            key: 'contractAmount',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.contractAmount || [],
        },
        {
            title: '预付款合同金额',
            dataIndex: 'preContractAmount',
            key: 'preContractAmount',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.preContractAmount || [],
        },
        {
            title: '尾款金额',
            dataIndex: 'balancePaymentAmount',
            key: 'balancePaymentAmount',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.balancePaymentAmount || [],
        },
        {
            title: '已开票金额',
            dataIndex: 'invoicedAmount',
            key: 'invoicedAmount',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.invoicedAmount || [],
        },
        {
            title: '到款金额',
            dataIndex: 'paymentAmount',
            key: 'paymentAmount',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.paymentAmount || [],
        },
        {
            title: '应收账款',
            dataIndex: 'accountsReceivable',
            key: 'accountsReceivable',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.accountsReceivable || [],
        },
        {
            title: '超期账款（发票超过6个月未到款）',
            dataIndex: 'overdueSixAccounts',
            key: 'overdueSixAccounts',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.overdueSixAccounts || [],
        },
        {
            title: '超期账款（发票超过3个月未到款）',
            dataIndex: 'overdueThreeAccounts',
            key: 'overdueThreeAccounts',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.overdueThreeAccounts || [],
        },
        {
            title: '预付款到款金额',
            dataIndex: 'prepayments',
            key: 'prepayments',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.prepayments || [],
        },
        {
            title: '预付款剩余金额',
            dataIndex: 'allPrepayments',
            key: 'allPrepayments',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.allPrepayments || [],
        },
        {
            title: '已收样未开票金额',
            dataIndex: 'sampleNoInvoiceAmount',
            key: 'sampleNoInvoiceAmount',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.sampleNoInvoiceAmount || [],
        },
        {
            title: '已下机未开票金额',
            dataIndex: 'offBoardNoInvoiceAmount',
            key: 'offBoardNoInvoiceAmount',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.offBoardNoInvoiceAmount || [],
        },
        {
            title: '已分析结束未开票金额',
            dataIndex: 'analysisOverNoInvoiceAmount',
            key: 'analysisOverNoInvoiceAmount',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.analysisOverNoInvoiceAmount || [],
        },
        {
            title: '总审批未到款申请原始数据/分析结果/返样项目总金额',
            dataIndex: 'applyRawDataNoPaymentAmount',
            key: 'applyRawDataNoPaymentAmount',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.applyRawDataNoPaymentAmount || [],
        },
        {
            title: '开票数量',
            dataIndex: 'numberOfInvoices',
            key: 'numberOfInvoices',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.numberOfInvoices || [],
        },
        {
            title: '退票数量',
            dataIndex: 'numberOfRefundedTickets',
            key: 'numberOfRefundedTickets',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.numberOfRefundedTickets || [],
        },
        {
            title: '邮寄项目数量',
            dataIndex: 'numberOfMailedItems',
            key: 'numberOfMailedItems',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.numberOfMailedItems || [],
        },
        {
            title: '多次邮寄项目数量',
            dataIndex: 'numberOfItemsMailedMultipleTimes',
            key: 'numberOfItemsMailedMultipleTimes',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.numberOfItemsMailedMultipleTimes || [],
        },
        {
            title: '订购干冰数量（kg)',
            dataIndex: 'orderTheQuantityOfDryIce',
            key: 'orderTheQuantityOfDryIce',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.orderTheQuantityOfDryIce || [],
        }
    ]
}
